import { useCallback } from "react"
import { To, useNavigate } from "react-router-dom"

export function useViewTransition() {
  const navigate = useNavigate()

  const navigateWithTransition = useCallback(
    (to: To) => {
      // Check if the browser supports View Transitions API
      if (!document.startViewTransition) {
        navigate(to)
        return
      }

      // Use the View Transitions API
      document.startViewTransition(() => {
        navigate(to)
      })
    },
    [navigate]
  )

  return navigateWithTransition
}
